import "./polyfills.js";
import "./index.css";
import "config/i18n";
import "config/moment";
import "config/datetime/datetime-locales";
import "config/sentry";
import React from "react";
import { createRoot } from "react-dom/client";
import Root from "./components/Root/Root";

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(<Root />);
